import { render, staticRenderFns } from "./ReportNewsLetterGeneration.vue?vue&type=template&id=bc86f1cc&scoped=true&"
import script from "./ReportNewsLetterGeneration.vue?vue&type=script&lang=js&"
export * from "./ReportNewsLetterGeneration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc86f1cc",
  null
  
)

export default component.exports